<div class="image-preview-container" (click)="goBack()">
  <swiper
    *ngIf="src"
    [config]="config"
  >
    <ng-template swiperSlide>
      <div class="swiper-zoom-container">
        <img [src]="src" />
      </div>
    </ng-template>
  </swiper>
  <!-- <img *ngIf="src" [src]="src" /> -->
  <qrcode
    *ngIf="qrCode"
    [qrdata]="qrCode"
    [width]="300"
    [errorCorrectionLevel]="'M'"
  >
  </qrcode>
</div>
